import(/* webpackMode: "eager" */ "/var/www/coco-app-platformhk/app/[locale]/error.tsx");
